import { Group, Button } from '@mantine/core';
import { NavLink, Link } from 'react-router-dom';
import { useState } from 'react';
import cn from 'clsx';
import { GiHamburgerMenu } from 'react-icons/gi';
import { WalletSuspense } from 'src/components/WalletSuspense/WalletSuspense';
import { HEADER_LINKS } from 'src/constants';
import { AprioriLogoGradient } from 'src/assets';

export function LayoutHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // @ts-ignore-next-line
  const renderWalletBtn = () => <w3m-button size="sm" balance="hide" />;

  const handleMobileNavClick = () => {
    setMobileMenuOpen(false);
  };

  const renderLinks = (onClick?: () => void) => {
    return HEADER_LINKS.map(({ to, label }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          cn(
            'group relative h-6 flex items-center px-2 transition-colors text-md lg:text-xs font-[700] text-main1 hover:text-primarypurple [&.link-active]:text-primarypurple',
            isActive ? 'link-active' : undefined
          )
        }
        target={!to.startsWith('/') ? '_blank' : undefined}
        onClick={() => onClick?.()}
      >
        <span
          className={cn(
            'hidden',
            'absolute inset-0',
            'border border-solid border-primarypurple rounded-[100px]',
            'transition-opacity opacity-0 group-[.link-active]:opacity-100 group-hover:opacity-100'
          )}
        />
        <span className="relative z-10">{label}</span>
      </NavLink>
    ));
  };

  return (
    <>
      <Group h="100%" justify="space-between" wrap="nowrap" gap={4}>
        <Group h="100%" gap={64}>
          <Group className="gap-1 md:gap-4" wrap="nowrap">
            <Link to="/">
              <AprioriLogoGradient className="h-5 md:h-7" />
            </Link>

            <div className="flex items-center h-5 px-1.5 rounded-[24px] bg-[rgba(124,77,255,0.28)] text-primarypurple text-[12px] md:text-[14px] font-[500]">
              Testnet
            </div>
          </Group>

          <Group h="100%" gap={32} className="max-lg:hidden">
            {renderLinks()}
          </Group>
        </Group>
        <Group className="gap-1 md:gap-4">
          <WalletSuspense
            buttonProps={{ className: 'max-md:h-8 max-md:px-2.5' }}
          >
            <Group gap={16} className="hidden lg:block">
              {renderWalletBtn()}
            </Group>
          </WalletSuspense>
          <GiHamburgerMenu
            size={24}
            className="lg:hidden cursor-pointer"
            color="var(--mantine-color-main-1)"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          />
        </Group>
      </Group>
      <div
        className={cn(
          'lg:hidden absolute z-50 top-[100%] left-0 w-full h-[100dvh] bg-brandblack px-[4%] py-4 flex flex-col gap-6 items-end',
          'translate-x-[100%] transition-transform duration-300'
        )}
        style={
          {
            ...(mobileMenuOpen ? { '--tw-translate-x': '0%' } : {}),
          } as React.CSSProperties
        }
      >
        {renderWalletBtn()}
        {renderLinks(handleMobileNavClick)}
      </div>
    </>
  );
}
